import React, { Component, Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CompoundButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ActionButton, Label, Spinner } from 'office-ui-fabric-react';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { SpinnerChargement } from '../components/Loader/SpinnerChargement';

import AuthContext from '../configAuth/Auth';

import logo from '../images/logo-eiffage-immobilier.png';

import Scriba from 'react-scriba';

import './LoginPage.css';
import { Data } from '../data/Data';

export class LoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            login: "",
            motDePasse: "",
            estIdentifie: false,
            onAfficheLoginForm: false,
            messageErreur: null,
            loading: false,

            affichageDialogMotDePasseOublie: false,
            affichageDialogMessageEnvoiEmail: false
        };
    }

    _onVerificationLoginAAD() {
        this.setState({
            messageErreur: null,
            loading: true
        });

        let onVerificationLoginAAD = Data._onVerificationLoginAAD(this.state.login);

        onVerificationLoginAAD
            .then(responseFetch => {
                let compte = responseFetch.reponseAPIobjet;

                if (compte !== null) {
                    AuthContext.login();
                }
                else {
                    this._onVerificationLoginCompte();
                }
            });
    }

    _onVerificationLoginCompte() {
        this.setState({
            messageErreur: null,
            loading: true
        });

        let onVerificationLoginCompte = Data._onVerificationLoginCompte(this.state.login);

        onVerificationLoginCompte
            .then(responseFetch => {
                const compteExiste = responseFetch.reponseAPIobjet;

                if (compteExiste) {
                    this.setState({
                        loading: false,
                        onAfficheLoginForm: true
                    });
                }
                else {
                    this.setState({ messageErreur: 'Login incorrect, veuillez respecter les majuscules et minuscules' });
                }
            });
    }

    _onIdentificationFormulaire() {
        this.setState({
            messageErreur: null,
            loading: true
        });

        let onIdentification = Data._onIdentification(this.state.login, this.state.motDePasse);

        onIdentification
            .then(responseFetch => {
                this.setState({
                    estIdentifie: responseFetch.reponseAPIobjet,
                    loading: false
                });

                if (this.state.estIdentifie) {
                    this.props.onIdentification();
                }
                else {
                    this.setState({ messageErreur: responseFetch.messageRetour });
                }
            });
    }

    _onAffichageDialogMotDePasseOublie = () => {
        this.setState({ affichageDialogMotDePasseOublie: true });
    }

    _onFermetureDialogMotDePasseOublie = () => {
        this.setState({
            affichageDialogMotDePasseOublie: false,
            affichageDialogMessageEnvoiEmail: true
        });
    }

    _onFermetureDialogMessageEnvoiEmail = () => {
        this.setState({
            affichageDialogMessageEnvoiEmail: false
        });
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    _contentBoutonConnexion() {
        return (<div className="ms-textAlignCenter EspaceBoutonChamps">
            <CompoundButton name="Connexion" primary={true} text="Connexion" secondaryText="S'identifier pour accéder à Eiffimmo." onClick={() => this._onVerificationLoginAAD()}></CompoundButton>
        </div>);
    }

    _contentLoginForm() {
        return (<Fragment>
            <div className="form-group">
                <TextField name="MotDePasse" label="Mot de passe" required={true} value={this.state.motDePasse} type='password' onChanged={valeur => this.setState({ motDePasse: valeur })} errorMessage={this.state.messageErreur} />
            </div>
            <div className="oubliMdp">
                <ActionButton name="oubliMdp" allowDisabledFocus onClick={() => this._onAffichageDialogMotDePasseOublie()} >J'ai oublié mon mot de passe</ActionButton>
            </div>
            {this.state.loading ? <SpinnerChargement label="Authentification en cours..." /> :
                <div className="ms-textAlignCenter">
                    <CompoundButton name="ConnexionPartieSecurisee" primary={true} text="Connexion" secondaryText="Accès à la partie sécurisée." onClick={() => this._onIdentificationFormulaire()}></CompoundButton>
                </div>
            }
        </Fragment>);
    }

    render = () => {
        return <Fragment>
            <Stack horizontalAlign="center" verticalAlign="center" verticalFill>

                <div className="main-div">
                    <div>
                        <div className="LogoLogin">
                            <img src={logo} alt="Logo" className="ms-hiddenMdDown" />
                        </div>
                        <div className="TitreLogin">
                            <div>Eiffimmo</div>
                        </div>
                    </div>
                    {this.state.onAfficheLoginForm ? <Link onClick={() => this.setState({ onAfficheLoginForm: false })}><Icon iconName="ChevronLeftMed" /> Retour</Link> : null}
                    <div className="form-group">
                        <TextField
                            name="Login"
                            label="Identifiant"
                            placeholder="Login"
                            required={true}
                            disabled={this.state.onAfficheLoginForm}
                            value={this.state.login}
                            onChanged={valeur => this.setState({ login: valeur })}
                            errorMessage={this.state.messageErreur}
                        />

                    </div>
                    {this.state.onAfficheLoginForm ? this._contentLoginForm() : this._contentBoutonConnexion()}

                    <Dialog
                        hidden={!this.state.affichageDialogMessageEnvoiEmail}
                        onDismiss={this._onFermetureDialogMessageEnvoiEmail}
                        dialogContentProps={{
                            type: DialogType.normal,
                            title: 'Envoi de réinitialisation de mot de passe',
                            subText: ''
                        }}
                        modalProps={{
                            isBlocking: false,
                            styles: { main: { maxWidth: 600 } }
                        }}
                    >
                        <div className="ms-Grid" dir="ltr">
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                    <Label>Nous vous avons envoyé un email avec un lien qui vous permettra de réinitialiser votre mot de passe</Label>
                                </div>
                            </div>
                        </div>
                        <DialogFooter>
                            <PrimaryButton onClick={() => this._onFermetureDialogMessageEnvoiEmail()} text="Fermer" />
                        </DialogFooter>
                    </Dialog>
                </div>
            </Stack>


            <DialogReinitialisationMotDePasse
                hidden={!this.state.affichageDialogMotDePasseOublie}
                login={this.state.login}
                onDismiss={() => this.setState({ affichageDialogMotDePasseOublie: false })}
                onValidation={this._onFermetureDialogMotDePasseOublie}
            />

        </Fragment>
    }
}

//<div className="displayNone">
//    <TextField
//        name="MdpCacheForTesting"
//        onChanged={valeur => this.setState({ motDePasse: valeur })}
//    />
//</div>



const DialogReinitialisationMotDePasse = (props) => {

    /*
    ******************************************************************************************************
    NOTE KP : test d'utilisation d'un composant fonctionnel >¨plus lisible sur petits composants ?
    PROPS :
        ATTRIBUTS :
            bool    hidden :                    détermine si dialog masquée ou non
            bool    login :                     login recherché par défaut
        METHODES :
            void    onDismiss :                 méthode appelée à la fermeture de la Dialog
            void    onValidation :              méthode appelée lorsque l'utilisateur clique sur "Envoyer"
    ******************************************************************************************************
    */

    const [methodeDeReinitialisation, setMethodeDeReinitialisation] = useState("login");
    const [valeurRecherchee, setValeurRecherchee] = useState(props.login || "");
    const [messageBarMessage, setMessageBarMessage] = useState(undefined);
    const [estEnCoursDeTraitement, setEstEnCoursDeTraitement] = useState(false);

    useEffect(() => {
        if (!props.hidden) { // Equivalent onOpen
            setMethodeDeReinitialisation("login");
            setValeurRecherchee(props.login || "");
            setMessageBarMessage(undefined);
            setEstEnCoursDeTraitement(false);
        }
    }, [props.hidden]);

    const _isDisabledBoutonEnvoyer = () => {
        if (valeurRecherchee === "") return true; // Désactivé si valeur non renseignée
        if (methodeDeReinitialisation === "email") return Scriba.officeUI().textField().texte().controleEmail(valeurRecherchee) !== ""; // Désactivé si format email incorrect
        return false;
    };

    const _onChangeChoiceGroup = (event, option) => {
        if (option.key === "login") setValeurRecherchee(props.login ? props.login : ""); // Rappel du login si connu
        else setValeurRecherchee("");
        setMethodeDeReinitialisation(option.key);
    };

    const _onValidation = () => {
        setEstEnCoursDeTraitement(true);
        const login = methodeDeReinitialisation === "login" ? valeurRecherchee : null;
        const email = methodeDeReinitialisation === "email" ? valeurRecherchee : null;
        let onDemandeDeModificationDeMotDePasse = Data._onDemandeDeModificationDeMotDePasse(login, email);

        onDemandeDeModificationDeMotDePasse
            .then(responseFetch => {
                if (responseFetch.codeRetour === 0) {
                    setValeurRecherchee("");
                    props.onValidation();
                }
                else {
                    setMessageBarMessage(responseFetch.messageRetour)
                }
                setEstEnCoursDeTraitement(false);
            });
    };

    return <Dialog
        hidden={props.hidden}
        onDismiss={props.onDismiss}
        modalProps={{ isBlocking: false }}
        dialogContentProps={{
            type: DialogType.normal,
            title: 'Réinit. de mot de passe'
        }}
    >
        {!messageBarMessage ? null :
            <MessageBar messageBarType={MessageBarType.severeWarning} isMultiline={true}>
                {messageBarMessage}
            </MessageBar>
        }
        <ChoiceGroup
            defaultSelectedKey={methodeDeReinitialisation}
            label="Je souhaite réinitialiser mon mot de passe à l'aide de mon :"
            options={
                [
                    { key: 'login', text: 'Identifiant', iconProps: { iconName: 'TextField' } },
                    { key: 'email', text: 'Adresse mail', iconProps: { iconName: 'Mail' } }
                ]
            }
            onChange={_onChangeChoiceGroup}
        />
        <TextField value={valeurRecherchee} onChange={(event, newValue) => setValeurRecherchee(newValue)} />
        <DialogFooter>
            {estEnCoursDeTraitement ?
                <Spinner styles={{ root: { display: "inline-block" } }} /> :
                <PrimaryButton onClick={_onValidation} text="Envoyer" disabled={_isDisabledBoutonEnvoyer()} />
            }
        </DialogFooter>
    </Dialog>

};

DialogReinitialisationMotDePasse.propTypes = {
    hidden: PropTypes.bool.isRequired,
    login: PropTypes.string,
    onDismiss: PropTypes.func.isRequired,
    onValidation: PropTypes.func.isRequired
};